import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { StatusCode } from "api/protocols";
import { useTranslation } from "react-i18next";
import Page from "components/page/Page";
import DataTable from "../../../../../components/dataTable/DataTable";
import { GetLiabilityWaivers } from "api/rpc/2024-04/facilityAdmin/facility/liabilityWaiver";
import MessageDisplay from "components/messageDisplay/MessageDisplay";

export interface ILiabilityWaiver {
  id: number;
  title: string;
  content?: string;
}

export default function LiabilityWaivers() {
  const history = useHistory();
  const { t } = useTranslation();
  const [liabilityWaivers, setLiabilityWaivers] = useState<ILiabilityWaiver[]>(undefined);

  useEffect(() => {
    void loadLiabilityWaivers();
  }, []);

  async function loadLiabilityWaivers() {
    if (liabilityWaivers !== undefined) {
      setLiabilityWaivers(undefined);
    }

    const res = await GetLiabilityWaivers(null, true);

    if (res.status !== StatusCode.OK) {
      setLiabilityWaivers([]);
      return;
    }

    setLiabilityWaivers(res.data);
  }

  return (
    <Page
      title={t("Liability Waivers")}
      primaryAction={{
        content: t("Create Liability Waiver"),
        action: () => history.push("/admin/settings/liability-waivers/new"),
        disabled: liabilityWaivers === undefined,
      }}
      narrow
    >
      <DataTable
        columns={[
          { label: t("Title"), width: "90%" },
          { label: "", width: "10%" },
        ]}
        loading={liabilityWaivers === undefined}
      >
        {liabilityWaivers?.length === 0 ? (
          <tr>
            <td colSpan={2}>
              <MessageDisplay
                icon="info-circle"
                title={t("No liability waivers found")}
                content={t("Create a new liability waiver to populate this list")}
              />
            </td>
          </tr>
        ) : (
          liabilityWaivers?.map((liabilityWaiver, index) => (
            <tr
              key={index}
              className={"clickable"}
              onClick={() => history.push(`/admin/settings/liability-waivers/${liabilityWaiver.id}`)}
            >
              <td>{liabilityWaiver.title}</td>
              <td>{<FontAwesomeIcon icon={["far", "pencil"]} />}</td>
            </tr>
          ))
        )}
      </DataTable>
    </Page>
  );
}
